import React, { useEffect, useLayoutEffect, useState } from 'react';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { useMyContext } from '../../../context/MyContext';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { FcPrint } from "react-icons/fc";
import { Base_Url, b2bdashboard, b2bAllShipmentList, shipmentlabel, cancleOrder, userdata, Url_For_View_Document, b2bPriceEstimator, } from '../../../config/config';
import { useNavigate } from 'react-router-dom';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { Package, Eye, ArrowRight } from 'lucide-react';
// import { BsFillCreditCard2FrontFill } from "react-icons/bs";
import { FaRupeeSign, FaShopify } from "react-icons/fa";
import { useAuth } from '../../../routes/Auth';
import Spinner from '../../../component/spinner/spinner';
import { FaJediOrder } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import OffersSlider from '../../../component/offerSlider/offerSlider';
// import { Edit, Trash2, Ship } from "lucide-react";
import B2BViewRateForword from '../../../component/b2b/models/priceEstimatorModelB2b';
import axios from 'axios';
import B2BViewAllShipment from '../../../component/b2b/models/viewAllShipmentModel'
import FullPageLoader from '../../../component/fullPageLoader/fullPageLoader';
import ImageSlider from '../../../component/Alloffers/alloffer';
import { Link } from 'react-router-dom';


const DashBoard = () => {
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenEdit, setIsPopupOpenEdit] = useState(false);
  const [shipments, setShipments] = useState([]);
  const [error, setError] = useState(null);
  const [filteredShipmemt, setFilteredShipment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totaldata, setTotalData] = useState();
  const navigate = useNavigate();
  const { logout } = useAuth()
  const [shipData, setShipData] = useState({});
  const { profile_flag, setProfile_flag } = useMyContext()
  const [isloading, isSetLoading] = useState(false);
  // const [loadingOrderId, setLoadingOrderId] = useState(null);
  const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  // const profile_Flag = localStorage.getItem('profile_flag');
  // const [loadingOrderIdShip, setLoadingOrderIdShip] = useState(null);

  const dashboardUrl = Base_Url + b2bdashboard;
  const cancleOrderApi = Base_Url + cancleOrder;

  useEffect(() => {
    fetchOrderData();
    totalData();
    fetchUserData()
  }, []);

  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    if (cusid) {
      try {
        const response = await fetch(url + "/" + cusid, {
          method: 'GET',
          headers: {
            'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        setProfile_flag(result.data.profile_flag)

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
  }

  const fetchOrderData = async () => {
    const url = `${Base_Url}${b2bAllShipmentList}/Pending`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setShipments(data.data || []);
        setFilteredShipment(data.data.slice(0, 9));
      }
      else if (data.status === "FAIL" && data.message === "Unauthorized access - Invalid token") {
        toast.error(data.message + " Please Login Again");
        handleLogout();
      }
      else {
        setError('Error fetching data: ' + data.message);
      }
    } catch (error) {
      setError('API error: ' + error.message);
    } finally {

    }
  };

  const totalData = async () => {
    try {
      const response = await fetch(dashboardUrl, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setTotalData(data || []);
        // setFilteredShipment(data.data.slice(0,9));
      } else {
        setError('Error fetching data: ' + data.message);
      }
    } catch (error) {
      setError('API error: ' + error.message);
    } finally {

    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filterShipment = shipments;
  const currentItems = filterShipment.slice(indexOfFirstItem, indexOfLastItem);
  // const total = shipments.reduce((sum, shipment) => sum + parseFloat(shipment.debit_amount), 0);

  // const handleViewClick = (order) => {
  //   setSelectedShipment(order)
  //   setIsPopupOpen(true);
  // };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleViewClickEdit = (order) => {
    fetchOrderData();
    setSelectedShipment(order)
    setIsPopupOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setIsPopupOpenEdit(false);
  };

  const data = totaldata?.chartData?.monthlyData;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(shipments.length).keys()]);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  // const handlePrintLabel = async (orderId) => {
  //   setLoadingOrderId(orderId);
  //   try {
  //     const response = await fetch(Base_Url + shipmentlabel, {
  //       method: 'POST',
  //       headers: {
  //         token,
  //         cus_id: cusid,
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ order_id: orderId }),
  //     });
  //     const data = await response.json();
  //     if (data.status === "SUCCESS") {
  //       const printUrl = data?.DownloadLink;
  //       if (printUrl) {
  //         const printLabel = Base_Url + printUrl
  //         window.open(printLabel, '_blank');
  //       }
  //       setLoadingOrderId(null);
  //     }
  //     else {
  //       toast.error(data.message || "url is not found please try again !");
  //       setLoadingOrderId(null);
  //     }
  //   } catch (error) {
  //     setError('API error: ' + error.message);
  //     setLoadingOrderId(null);
  //   }
  // };

  const getSelectedOrderIds = () => {
    if (selectAll) {
      // If all are selected, return all order IDs
      return currentItems.map(shipment => shipment.order_id);
    } else {
      // For individual selections, map correctly to the displayed items
      return selectedRows.map(index => {
        // Make sure we're accessing the correct item in currentItems
        return currentItems[index].order_id;
      });
    }
  };

  // const totadldata = {
  //   data: {
  //     total_order: 0,
  //     total_delivered: 0,
  //     total_cod: 109,
  //     total_prepaid: 0,
  //     total_shopify: 0,
  //     month: "Apr"
  //   }
  // };

  const handleDownload = async () => {
    const selectedOrderIds = getSelectedOrderIds();
    const urlForDownloadBulkLabel = Base_Url + shipmentlabel;
    const payload = {
      order_ids: selectedOrderIds
    };

    const headers = {
      token: token,
      cus_id: cusid,
      'Content-Type': 'application/json',
    };
    isSetLoading(true);
    try {
      const response = await fetch(urlForDownloadBulkLabel, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const pdf = data.DownloadLink;
        const downloadPdf = Url_For_View_Document + pdf;
        if (downloadPdf) {
          window.open(downloadPdf, "_blank")
        }
        isSetLoading(false);
      }
      else {
        toast.error(data.message);
        isSetLoading(false);
      }
    } catch (error) {
      console.error('Error downloading orders:', error);
      isSetLoading(false);
    }
  };

  const handleCancelOrder = async (orderId) => {
    try {
      setLoadingOrderIdCancleOrder(orderId); // Show loader on button
      const response = await fetch(`${cancleOrderApi}/${orderId}`, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        // setTotalData((prevData) => prevData.filter(item => item.order_id !== orderId)); // Remove canceled order from state
        toast.success("shipment canceled successfully!");
      } else {
        toast.error(`Failed to cancel order: ${data.message}`);
      }
    } catch (error) {
      toast.error(`API error: ${error.message}`);
    } finally {
      setLoadingOrderIdCancleOrder(null);
    }
  };


  // const handleDelete = (order) => {
  //   // Add your delete logic here
  // };

  // const getStatusColor = (status) => {
  //   switch (status.toLowerCase()) {
  //     case 'pending':
  //       return 'bg-yellow-100 text-yellow-800 border-yellow-200';
  //     case 'shipped':
  //       return 'bg-blue-100 text-blue-800 border-blue-200';
  //     case 'delivered':
  //       return 'bg-green-100 text-green-800 border-green-200';
  //     case 'cancelled':
  //       return 'bg-red-100 text-red-800 border-red-200';
  //     default:
  //       return 'bg-gray-100 text-gray-800 border-gray-200';
  //   }
  // };

  // const hanldeShipNow = async (order) => {
  //   const apiUrl = Base_Url + b2bPriceEstimator;
  //   const headers = {
  //     cus_id: cusid,
  //     token: token,
  //     "Content-Type": "application/json",
  //   };


  //   setIsPageLoading(true);
  //   setLoadingOrderIdShip(order.orderId);

  //   const pickupLocation = JSON.parse(order.pickup_location);
  //   const dropoffLocation = JSON.parse(order.dropoff_location);
  //   const invoices = JSON.parse(order.invoices || "[]");
  //   const invoiceAmount = invoices.length > 0 ? parseFloat(invoices[0].inv_amt) : 0;
  //   const payload = {
  //     retailer_id: parseInt(order.retailer_id),
  //     origin_pincode: pickupLocation.zip,
  //     destination_pincode: dropoffLocation.zip,
  //     insorance: order.insurence,
  //     weight: parseFloat(order.total_weight),
  //     invoice_value: invoiceAmount,
  //     dimensions: [
  //       {
  //         total_length: order.total_length,
  //         total_width: order.total_width,
  //         total_height: order.total_height,
  //       },
  //     ],
  //   };

  //   try {
  //     const response = await axios.post(apiUrl, payload, { headers });

  //     if (response.data.status === "success") {
  //       setShipData(response.data);
  //       handleViewClick(order);
  //       setIsPageLoading(false);
  //     } else {
  //       // ✅ Handle API-level errors
  //       const errorMessage =
  //         response.data?.message ||
  //         response.data?.messages?.error ||
  //         response.data?.error ||
  //         "Something went wrong";
  //       setIsPageLoading(false);

  //       toast.error(errorMessage);
  //     }
  //   } catch (error) {
  //     // ✅ Handle network / unexpected errors
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       error.response?.data?.messages?.error ||
  //       error.response?.data?.error ||
  //       error.message;
  //     setIsPageLoading(false);

  //     toast.error("API Error: " + errorMessage);
  //   } finally {
  //     setLoadingOrderIdShip(null);
  //     setIsPageLoading(false);
  //   }
  // };

  return (
    <div className={`h-screen  flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      {
        profile_flag === "0" && role != "admin" ? <marquee className=" text-red-500 font-medium "> Your Kyc Is Pending Please Contact To The Support Team on support@pickupxpress.com</marquee> : ""
      }
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}
        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />
        <div
          className={`flex-1  overflow-auto transition-all duration-300 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-gray-800" : "bg-white"}`}>
          {/* DashBoard Content */}
          <div className="p-4 md:p-6 min-h-screen transition-all duration-300 rounded-custom">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-6">
              {/* Card 1 - Combined Total Orders */}
              {/* <div className="bg-gradient-to-r from-[#06bb6d] to-[#036a3e] rounded-lg p-4 max-h-[150px] transform transition-transform sm:max-w-[220px]"> */}
              <div
                className={`bg-gradient-to-r from-[#06bb6d] to-[#036a3e] rounded-lg p-4 max-h-[150px] transform transition-all duration-300 hoverL:scale-[105]
                          ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
              >
                <p className="text-white text-lg font-sans">Orders</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.total_order}</p>
                <div className="text-white text-xs font-sans mt-1 space-y-0.5">
                  <div className="flex justify-between cursor-pointer"
                    onClick={() => {
                      window.location.href = '/shipments/all';
                    }}>
                    <span>Delivered:</span>
                    <span className="font-medium">{totaldata?.data?.total_delivered}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>COD:</span>
                    <span className="font-medium">{totaldata?.data?.total_cod}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Prepaid:</span>
                    <span className="font-medium">{totaldata?.data?.total_prepaid}</span>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-1">
                  {/* <ShoppingCart className="text-white h-5 w-5" /> */}
                  {/* <span className="text-white text-lg">⋮</span> */}
                </div>
              </div>

              {/* Card 2 - Total NDR (Clickable) */}
              <div
                className={`bg-gradient-to-r from-[#7f04a6] to-[#62059e] rounded-lg p-4 transform transition-transform max-h-[150px] sm:max-w-[220px] cursor-pointer hover:scale-105 ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
              // onClick={() => {
              //   // Navigate to NDR page
              //   // Replace with your actual navigation logic
              //   window.location.href = '/disputes/NDR'; // or use your router navigation
              // }}
              >
                <p className="text-white text-lg font-sans">NDR & RTO</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.total_all_ndr || '0'}</p>
                {/* <p className="text-white text-sm font-sans">Non-Delivery Reports {totaldata?.data?.month}</p> */}
                <div className="text-white text-xs font-sans mt-1 space-y-0.5">
                  <div className="flex justify-between">
                    <span>NDR:</span>
                    <span className="font-medium">{totaldata?.data?.total_ndr}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>RTO:</span>
                    <span className="font-medium">{totaldata?.data?.total_rto}</span>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <Package className="text-white h-6 w-6" />
                  {/* <span className="text-white text-2xl">⋮</span> */}
                </div>
              </div>

              {/* Card 3 - COD Remittance (Clickable) */}
              <div
                className={`bg-gradient-to-r from-[#a6042b] to-[#e81581] rounded-lg p-4 transform transition-transform max-h-[150px] sm:max-w-[220px] cursor-pointer hover:scale-105 ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
              // onClick={() => {
              //   const role = localStorage.getItem('role'); // or get from context/auth state
              //   if (role === 'admin') {
              //     window.location.href = '/payments/remmitanceList';
              //   } else {
              //     window.location.href = '/payments/remmitance';
              //   }
              // }}
              >
                <p className="text-white text-lg font-sans">COD Remittance</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.cod_remittance || '₹0'}</p>
                <p className="text-white text-sm font-sans">Cash on Delivery {totaldata?.data?.month}</p>
                <div className="flex justify-between items-center mt-2">
                  <FaRupeeSign className="text-white h-6 w-6" />
                  <span className="text-white text-2xl">⋮</span>
                </div>
              </div>

              {/* Card 4 - Returns/RTO */}
              {/* <div className={`bg-gradient-to-r from-[#e85a15] to-[#a63904] rounded-lg p-4 transform transition-transform max-h-[150px]  cursor-pointer hover:scale-105 sm:max-w-[220px] ${!isToggleSidebar ? 'sm:max-w-[300px]' : 'sm:max-w-[220px]'}`}
                            onClick={() => {
                              // Navigate to NDR page
                              // Replace with your actual navigation logic
                              window.location.href = '/disputes/NDR'; // or use your router navigation
                            }}>
                            <p className="text-white text-lg font-sans">Total RTO</p>
                            <p className="text-white text-2xl font-medium">{totaldata?.data?.total_rto || '0'}</p>
                            <p className="text-white text-sm font-sans">Return to Origin {totaldata?.data?.month}</p>
                            <div className="flex justify-between items-center mt-2">
                              <svg className="text-white h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414L2.586 7l3.707-3.707a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                              <span className="text-white text-2xl">⋮</span>
                            </div>
                          </div> */}

              {/* Card 5 -  Weight Disputes */}

              <div className={`bg-gradient-to-r from-[#0072bb] to-[#004a76] rounded-lg p-4 max-h-[150px] transform transition-transform  cursor-pointer hover:scale-105 sm:max-w-[220px] ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'} `}
              // onClick={() => {

              //   const targetUrl = role === 'admin'
              //     ? '/disputes/allWeightDisputes'
              //     : '/disputes/weight';
              //   window.location.href = targetUrl;
              // }}
              >
                <p className="text-white text-lg font-sans">Weight Disputes</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.weight_disputes || '₹0'}</p>
                <p className="text-white text-sm font-sans">Total Weight Disputes {totaldata?.data?.month}</p>
                <div className="flex justify-between items-center mt-2">
                  <FaJediOrder className="text-white h-6 w-6" />
                  <span className="text-white text-2xl">⋮</span>
                </div>
              </div>
            </div>


            {/* Card 5 - Total Sales */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">

              {/* Left Section - Chart */}
              <div className="col-span-2 md:col-span-3 bg-custom-gradient rounded-lg p-6 flex flex-col h-auto sm:min-h-80 shadow-lg">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-white text-lg font-medium mb-2">Total Sales</h3>
                    <p className="text-white text-4xl font-bold">
                      ₹ {totaldata?.chartData?.quarterData?.total_sales}
                    </p>
                  </div>
                  <button className="text-white text-2xl font-bold hover:bg-white/10 rounded px-2">⋮</button>
                </div>

                <div className="flex-1 min-h-[220px] mt-4">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                      data={data}
                      margin={{ top: 5, right: 10, left: -20, bottom: 5 }}
                    >
                      <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="rgba(255,255,255,0.2)"
                        vertical={false}
                      />
                      <XAxis
                        dataKey="name"
                        stroke="rgba(255,255,255,0.7)"
                        tick={{ fill: "rgba(255,255,255,0.8)" }}
                      />
                      <YAxis
                        stroke="rgba(255,255,255,0.7)"
                        tick={{ fill: "rgba(255,255,255,0.8)" }}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          border: "none",
                          borderRadius: "8px",
                        }}
                      />
                      <Line
                        type="monotone"
                        dataKey="shipments"
                        stroke="#8884d8"
                        strokeWidth={1}
                        activeDot={{ r: 8 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* Right Section - Image Slider */}
              <div className="col-span-2 md:col-span-1 bg-gray-100 rounded-lg h-auto sm:min-h-80 shadow-lg overflow-hidden">
                <ImageSlider />
              </div>
            </div>
            <div className={`rounded-custom mt-5 mb-5  shadow-custom-light ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white dark:shadow-custom-dark" : "bg-white"}`}>
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center space-x-3">
                  <Package className={`w-6 h-6 ml-4 ${isDarkMode ? 'text-blue-300' : 'text-blue-600'}`} />
                  <p className="text-xl font-medium mt-4 mb-4">Recent Orders</p>
                </div>

                <Link
                  to="/b2b/shipments/list"
                  className="
      flex items-center space-x-2
      text-blue-500
      hover:text-blue-700
      transition-colors
      duration-200
      mr-4
    "
                >
                  <span>View All Orders</span>
                  <ArrowRight className="w-4 h-4 mr-4" />
                </Link>
              </div>
            </div>
            <div>
              {(selectedRows.length > 0 || selectAll) && (
                <div className="mb-4">
                  <Button
                    onClick={handleDownload}
                    disabled={isloading}
                    sx={{
                      color: "black", // Ensures text is black
                      textTransform: "none", // Prevents automatic capitalization
                    }}
                    className="flex items-center gap-3  dark:text-white rounded-custom dark:shadow-custom-dark  shadow-custom-light  transition-all duration-200 font-medium"
                  >
                    {isloading ? (
                      <div className="flex items-center gap-2">
                        <Spinner className="w-4 h-4 animate-spin" />
                        <span>Downloading...</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <FaDownload className="w-4 h-4" />
                        <span>Download Selected ({selectAll ? shipments.length : selectedRows.length})</span>
                      </div>
                    )}
                  </Button>
                </div>
              )}
            </div>
            <div className="bg-white rounded-lg shadow-sm overflow-hidden dark:bg-darkmodeColor dark:text-white">
              <div className="overflow-x-auto dark:bg-darkmodeColor dark:text-white ">
                {/* <table className="min-w-full table-auto custom-scrollbar overflow-y-auto dark:bg-darkmodeColor dark:text-white">
                  <thead className='bg-gradient-to-r from-[#0540a6] to-[#0650c4] text-white text-[10px] dark:bg-darkmodeColor dark:text-white'> */}
                <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                  <thead className="bg-customPurple rounded-xl text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                    <tr>
                      <th className="p-2 text-left font-medium">
                        <input
                          type="checkbox"
                          disabled
                          checked={selectAll}
                          onChange={handleSelectAll}
                          className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </th>
                      <th className="p-2 text-left font-medium">Order ID</th>
                      {role === "admin" && (
                        <th className="p-2 text-left font-medium">User ID</th>
                      )}
                      <th className="p-2 text-left font-medium">Customer Info</th>
                      <th className="p-2 text-left font-medium">Payment</th>
                      <th className="p-2 text-left font-medium">Product Details</th>
                      <th className="p-2 text-left font-medium">Status</th>
                      {/* <th className="p-2 text-left font-medium">Weight</th> */}
                      {/* <th className="p-2 text-left font-medium">Boxes</th> */}
                      <th className="p-2 text-left font-medium">Actions</th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                    {shipments.map((order, index) => (
                      <tr
                        key={order.id}
                        className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                          ? "bg-white dark:bg-darkmodeColor"
                          : "bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]"
                          }`}
                      >
                        {/* Checkbox */}
                        <td className="p-2">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(index)}
                            disabled
                            onChange={() => handleRowSelect(index)}
                            className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </td>

                        {/* Order ID with tooltip */}
                        <td
                          className={`relative group p-2 text-xs font-medium transition-colors ${!['pending', 'cancelled'].includes(order.status?.toLowerCase())
                            ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300'
                            : 'text-gray-400 dark:text-gray-500 cursor-not-allowed'
                            }`}

                        >
                          {order.order_id || 'Unavailable'}

                          {/* {!['Pending', 'cancelled'].includes(order.status?.toLowerCase()) && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                              📦 Track your shipment status here!
                              <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                            </div>
                          )} */}
                        </td>

                        {role === 'admin' && (
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            {order.user_id}
                          </td>
                        )}

                        {/* Customer Info */}
                        <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">
                          <div className="font-semibold">
                            {JSON.parse(order.dropoff_location)?.consignee_name}
                          </div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            {JSON.parse(order.dropoff_location)?.phone}
                          </div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            {JSON.parse(order.dropoff_location)?.email}
                          </div>
                        </td>

                        {/* Payment */}
                        <td className="p-2 text-xs text-gray-700 dark:text-gray-300">
                          <div className="font-semibold text-green-600 dark:text-green-400">
                            ₹{order.cod_amount}
                          </div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400 uppercase">
                            {order.payment_mode}
                          </div>
                        </td>

                        {/* Product Details */}
                        <td className="p-2 text-xs text-gray-700 dark:text-gray-300">
                          {(() => {
                            let dims = [];
                            let details = [];

                            try {
                              dims = order.dimensions ? JSON.parse(order.dimensions) : [];
                              details = order.shipment_details ? JSON.parse(order.shipment_details) : [];
                            } catch (e) {
                              console.error("Invalid JSON:", e);
                            }

                            // total weight (sum of all boxes from shipment_details)
                            const totalWeight = details.reduce((sum, d) => sum + (d.weight || 0), 0);

                            return (
                              <>
                                {/* Show total box count */}
                                {/* <div className="font-medium">{order.total_boxes || dims.length}</div> */}

                                {/* Show Qty and total weight */}
                                <div className="text-[10px] text-gray-500 dark:text-gray-400">
                                  Qty: {order.total_boxes || dims.length} | Weight: {totalWeight}g
                                </div>

                                {/* Show all box dimensions */}
                                <div className="text-[10px] text-gray-500 dark:text-gray-400">
                                  {dims.map((d, i) => (
                                    <div key={i}>
                                      {d.length}×{d.width}×{d.height}cm ({d.box_count} box)
                                    </div>
                                  ))}
                                </div>
                              </>
                            );
                          })()}
                        </td>


                        {/* Status */}
                        <td className='p-2'>
                          {order.status?.length > 15 ? (
                            <div className="group relative">
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${order.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : order.status.toLowerCase() === 'in transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : order.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : order.status === 'Seller cancelled the order' || order.status === 'Cancel' || order.status === 'cancelled' || order.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : order.status.toLowerCase() === 'delivered' || order.status === 'Delivered' || order.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : order.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${order.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : order.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : order.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : order.status === 'Seller cancelled the order' || order.status === 'Cancel' || order.status === 'cancelled' || order.status === 'cancel'
                                        ? 'bg-white'
                                        : order.status.toLowerCase() === 'delivered' || order.status === 'Delivered' || order.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : order.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {order.status.substring(0, 8)}...
                              </span>
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                {order.status}
                                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                              </div>
                            </div>
                          ) : (
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${order.status === 'Manifested'
                              ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                              : order.status === 'In Transit'
                                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                : order.status.toLowerCase() === 'out for delivery'
                                  ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                  : order.status === 'Seller cancelled the order' || order.status === 'Cancel' || order.status === 'cancelled' || order.status === 'cancel'
                                    ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                    : order.status.toLowerCase() === 'delivered' || order.status === 'Delivered' || order.status === 'Delivered to consignee'
                                      ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                      : order.status.toLowerCase() === 'pending'
                                        ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                        : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                              }`}>
                              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${order.status === 'Manifested'
                                ? 'bg-white animate-pulse'
                                : order.status === 'In Transit'
                                  ? 'bg-white animate-bounce'
                                  : order.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-white animate-bounce'
                                    : order.status === 'Seller cancelled the order' || order.status === 'Cancel' || order.status === 'cancelled' || order.status === 'cancel'
                                      ? 'bg-white'
                                      : order.status.toLowerCase() === 'delivered' || order.status === 'Delivered' || order.status === 'Delivered to consignee'
                                        ? 'bg-white animate-pulse'
                                        : order.status.toLowerCase() === 'pending'
                                          ? 'bg-white animate-pulse'
                                          : 'bg-gray-400 dark:bg-gray-500'
                                }`}></span>
                              {order.status}
                            </span>
                          )}
                        </td>

                        {/* <td className="p-2 text-xs text-gray-700 dark:text-gray-300">
                          {order.total_weight} kg
                        </td>

                        
                        <td className="p-2 text-xs text-gray-700 dark:text-gray-300">
                          {order.total_boxes}
                        </td> */}

                        {/* Actions */}
                        <td className="p-2">
                          <div className="flex items-center gap-1">
                            <Button
                              onClick={() => handleViewClickEdit(order)}
                              variant="contained"
                              color="primary"
                              size="small"
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                              style={{
                                backgroundColor: '#3b82f6',
                                '&:hover': { backgroundColor: '#2563eb' }
                              }}
                            >
                              <IoMdEye className="text-xs" />
                            </Button>
                            <Button
                              onClick={() => handleCancelOrder(order.order_id)}
                              variant="contained"
                              color="error"
                              size="small"
                              disabled={loadingOrderIdCancleOrder === order.order_id || order.status?.toLowerCase() !== "pending"}
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                              style={{
                                backgroundColor: '#ef4444',
                                '&:hover': { backgroundColor: '#dc2626' }
                              }}
                            >
                              {loadingOrderIdCancleOrder === order.order_id ? (
                                <span className="animate-spin text-xs">⏳</span>
                              ) : (
                                <RxCross2 className="text-xs" />
                              )}
                            </Button>

                            {/* <Button
                              onClick={() => hanldeShipNow(order)}
                              variant="contained"
                              size="small"
                              disabled={loadingOrderIdShip === order.order_id || order.status?.toLowerCase() !== "pending"}
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow group relative"
                              style={{
                                backgroundColor: '#10b981',
                                '&:hover': { backgroundColor: '#059669' }
                              }}
                            >
                              {loadingOrderIdShip === order.order_id ? (
                                <span className="animate-spin text-xs inline-block">⟳</span>
                              ) : (
                                <span className="text-xs">🚚</span>
                              )}
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                Ship Now
                                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-900 dark:border-t-gray-800"></div>
                              </div>
                            </Button> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
      <B2BViewRateForword isopen={isPopupOpen} onClose={handleClose} data={shipData} shipment={selectedShipment} />
      <B2BViewAllShipment isopen={isPopupOpenEdit} onClose={handleCloseEdit} shipment={selectedShipment} />
    </div>
  );
};

export default DashBoard;